import { Fragment, type ReactNode } from 'react';

type MarkedTextOptions = {
  highlightColor?: string;
  markedWeight?: 'bold' | 'regular';
  markedColor?: string;
};

const parseSegment = (
  segment: string,
  key: string,
  options?: MarkedTextOptions
): ReactNode => {
  if (options?.highlightColor) {
    return (
      <span key={key} style={{ color: options.highlightColor }}>
        {segment}
      </span>
    );
  }

  if (options?.markedWeight === 'regular') {
    return (
      <span
        key={key}
        style={options.markedColor ? { color: options.markedColor } : undefined}
      >
        {segment}
      </span>
    );
  }

  return (
    <strong
      key={key}
      style={options?.markedColor ? { color: options.markedColor } : undefined}
    >
      {segment}
    </strong>
  );
};

export const parseMarkedText = (
  text = '',
  options?: MarkedTextOptions
): ReactNode[] => {
  if (!text) {
    return [];
  }

  const parts: ReactNode[] = [];
  const regex = /%([^%]+)%/g;
  let lastIndex = 0;
  let match = regex.exec(text);

  while (match) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    parts.push(parseSegment(match[1], `${match.index}`, options));
    lastIndex = regex.lastIndex;
    match = regex.exec(text);
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts;
};

export const renderMultilineMarkedText = (
  text = '',
  options?: MarkedTextOptions
) =>
  text.split('\n').map((line, index) => (
    <Fragment key={`${line}-${index}`}>
      {index > 0 ? <br /> : null}
      {parseMarkedText(line, options)}
    </Fragment>
  ));
